import type { CotizacionTareaCostos } from '@/lib/types'
import { formatCurrency, r2 } from '@/lib/utils'

/** Renders the structured cost breakdown for a cotización task */
export default function CostBreakdown({ costos, moneda }: { costos: CotizacionTareaCostos; moneda: string }) {
  const costoDev = r2(costos.sesiones_ia * costos.tarifa_dev_hora)
  const costoQA = r2(costos.horas_qa * costos.tarifa_qa_hora)
  const costoInput = r2(costos.tokens_input_mtok * costos.precio_input_mtok)
  const costoThinking = r2(costos.tokens_thinking_mtok * costos.precio_thinking_mtok)
  const costoOutput = r2(costos.tokens_output_mtok * costos.precio_output_mtok)
  const costoTokens = r2(costoInput + costoThinking + costoOutput)
  const totalTokensMtok = r2(costos.tokens_input_mtok + costos.tokens_thinking_mtok + costos.tokens_output_mtok)
  const totalCosto = r2(costoDev + costoQA + costoTokens)

  return (
    <div className="cot-task-costs">
      <h4>Desglose de Costos</h4>

      <table className="cot-task-costs-table">
        <thead>
          <tr><th>Concepto</th><th>Detalle</th><th>Tarifa</th><th>Subtotal</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Desarrollador Fullstack</strong></td>
            <td>{costos.sesiones_ia} sesión{costos.sesiones_ia !== 1 ? 'es' : ''} IA × 1h</td>
            <td>${costos.tarifa_dev_hora.toFixed(2)}/h</td>
            <td><strong>{formatCurrency(costoDev, moneda)}</strong></td>
          </tr>
          <tr>
            <td><strong>QA — Pruebas funcionales</strong></td>
            <td>{costos.horas_qa}h</td>
            <td>${costos.tarifa_qa_hora.toFixed(2)}/h</td>
            <td><strong>{formatCurrency(costoQA, moneda)}</strong></td>
          </tr>
          <tr>
            <td><strong>Infraestructura IA</strong></td>
            <td>~{totalTokensMtok.toFixed(1)}M tokens</td>
            <td>Variable</td>
            <td><strong>{formatCurrency(costoTokens, moneda)}</strong></td>
          </tr>
          <tr className="cot-task-costs-total">
            <td colSpan={3}><strong>TOTAL REQUERIMIENTO</strong></td>
            <td><strong>{formatCurrency(totalCosto, moneda)}</strong></td>
          </tr>
        </tbody>
      </table>

      <div className="cot-task-costs-tokens">
        <h5>Detalle de Tokens IA</h5>
        <table className="cot-task-costs-table">
          <thead>
            <tr><th>Tipo Token</th><th>Volumen</th><th>Precio / M tokens</th><th>Costo</th></tr>
          </thead>
          <tbody>
            <tr><td>Input</td><td>{(costos.tokens_input_mtok * 1).toFixed(1)}M tokens</td><td>${costos.precio_input_mtok.toFixed(2)}</td><td>{formatCurrency(costoInput, moneda)}</td></tr>
            <tr><td>Thinking</td><td>~{(costos.tokens_thinking_mtok * 1).toFixed(1)}M tokens</td><td>${costos.precio_thinking_mtok.toFixed(2)}</td><td>{formatCurrency(costoThinking, moneda)}</td></tr>
            <tr><td>Output</td><td>{(costos.tokens_output_mtok * 1).toFixed(1)}M tokens</td><td>${costos.precio_output_mtok.toFixed(2)}</td><td>{formatCurrency(costoOutput, moneda)}</td></tr>
            <tr className="cot-task-costs-total"><td colSpan={3}><strong>Total API</strong></td><td><strong>{formatCurrency(costoTokens, moneda)}</strong></td></tr>
          </tbody>
        </table>
        <p className="cot-task-costs-note">Tokens de Thinking estimados en ~1.5× Output. Costo real puede variar ±15%.</p>
      </div>
    </div>
  )
}
